import axiosInstance from '../../../../config/axiosInstance';
const  DimensionService = {
    async GetAllDimensions(redirectCallback,StockID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetDimensionLabel?StockID=${StockID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    }
};

export default DimensionService;